import { Device } from "@domain/product/monitoring/device";
import { Family } from "@domain/product/monitoring/family/family";
import { MonitoringProductCategoryDto } from "@lib/dtos/monitoring/monitoring-product-category.dto";

export class MonitoringProductCategory extends MonitoringProductCategoryDto {
  constructor(families: Family[], devices: Device[]) {
    super();
    this.families = families;
    this.devices = devices;
  }
}
